export const hobbies = [
  {
    title: "Reading Books",
    proofs: [],
  },
  {
    title: "Travelling",
    proofs: [],
  },
  {
    title: "Drawing, Painting",
    proofs: [],
  },
  {
    title: "Photography",
    proofs: [],
  },
];

export const skills = [
  {
    category: "Programming Languages",
    techstack: ["Python", "Java", "C"],
  },
  {
    category: "Web Development",
    techstack: ["HTML", "CSS", "Bootstrap", "Material UI"],
  },
  {
    category: "Front-end",
    techstack: ["ReactJS", "jQuery"],
  },
  {
    category: "Backend",
    techstack: ["NodeJS", "ExpressJS", "PHP"],
  },
  {
    category: "Database",
    techstack: ["MySQL", "MongoDB"],
  },
  {
    category: "API",
    techstack: ["RESTful API", "AJAX", "Axios"],
  },
  {
    category: "Framework",
    techstack: ["Flask"],
  },
  {
    category: "Version Control",
    techstack: ["Git", "GitHub"],
  },
  {
    category: "IDEs",
    techstack: ["VS Code", "PyCharm", "Jupyter NoteBook"],
  },
  {
    category: "Tools",
    techstack: ["Postman", "Xamp"],
  },
  {
    category: "Machine Learning",
    techstack: ["Pandas", "Numpy", "TensorFlow", "SciKit Learn", "MatPlot lib"],
  },
  {
    category: null,
    techstack: ["Data Structure And Algorithm", "Object Oriented Programing"],
  },
];

export const softskills = [
  "Effective Communication",
  " Team Collaboration",
  "Decision Making",
  " Flexibility",
  "Self - Motivation",
];

export const skilllist = {
  Css: 85,
  React: 60,
  MongoDB: 90,
  Python: 75,
  Php: 70,
  JavaScript: 75,
};

export const info = {
  Name: "Yuvaraja D",
  email: "yuvaraj3303@gmail.com",
  cgpa: 8.42,
  gihub: "https://github.com/Yuv-Rajd",
};
